export enum LoginStatus {
	idle = 1,
	inProgress = 2,
}
